import { render, staticRenderFns } from "./folder_thumbnail.vue?vue&type=template&id=eb74d48a&scoped=true&"
import script from "./folder_thumbnail.vue?vue&type=script&lang=js&"
export * from "./folder_thumbnail.vue?vue&type=script&lang=js&"
import style0 from "./folder_thumbnail.vue?vue&type=style&index=0&id=eb74d48a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb74d48a",
  null
  
)

export default component.exports